import { Box, Flex, IconButton, Text } from "monday-ui-react-core";
import { Duplicate } from "monday-ui-react-core/icons";
import { useMemo } from "react";

import { CommandEditor } from "@/components/CommandEditor";
import type { Command } from "@/services/runcli";

type Props = {
  onCopy: () => void;
  command: Command;
};

export function CommandListItem({ onCopy, command }: Props) {
  const note = useMemo(() => ({ __html: command.note.replace(/`([^`]+)`/g, "<code>$1</code>") }), [command.note]);

  return (
    <Box
      backgroundColor={Box.backgroundColors.ALL_GREY_BACKGROUND_COLOR}
      rounded={Box.roundeds.MEDIUM}
      marginY={Box.marginYs.SMALL}
      padding={Box.paddings.MEDIUM}
    >
      <Flex gap={Flex.gaps.XS} style={{ alignItems: "normal" }}>
        <IconButton icon={Duplicate} onClick={onCopy} tooltipContent="Copy to Run editor"></IconButton>
        <Flex gap={Flex.gaps.SMALL} direction={Flex.directions.COLUMN} align={Flex.align.START}>
          <Text type={Text.types.TEXT1} weight={Text.weights.BOLD}>
            {command.shortDescription}
          </Text>
          <Text type={Text.types.TEXT1} ellipsis={false}>
            {command.longDescription}
          </Text>
          {command.note && (
            <Text type={Text.types.TEXT1} color={Text.colors.SECONDARY} ellipsis={false}>
              <span dangerouslySetInnerHTML={note}></span>
            </Text>
          )}
        </Flex>
      </Flex>
      <Box marginTop={Box.marginTops.MEDIUM}>
        <CommandEditor value={command.text} disabled={true} autoHeight={true} />
      </Box>
    </Box>
  );
}
